<div class="content-wrapper-inner">
  <div class="page-content">
    <div class="mb-20">
      <app-appscripts-mo-sms-filter (onSubmit)="onFilter($event)"></app-appscripts-mo-sms-filter>
    </div>
    <div class="pos-relative">
      <app-appscripts-mo-sms-table (changeBatch)="selectedRows = $event"></app-appscripts-mo-sms-table>
      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{selectedRows.length}} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <div class="text-icon-holder" (click)="onClickCopyPhones()">
            <span class="icon">
              <i class="fa fa-mobile-phone"></i>
            </span>
            <span class="text">Copy phones</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #copyPhonesModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Phones</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body info-content">
    <textarea [(ngModel)]="copyPhonesText" (click)="onClickCopyPhonesControl($event)" class="form-control copy-control" [attr.rows]="copyPhonesTextControlRows"
      readonly></textarea>
  </div>
</ng-template>
